import EditAccount from './ui/editAccount.jsx';

export default EditAccount;